import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import {
  PlaceDiscoveryDocument,
  PlacePageDocument,
  PlacePageMarketRegionsDocument,
  PlacePageStaysDocument,
} from 'hooks/useQueries'

// One key per PlacePages::SsrQuery operation.
type PlaceSsr = {
  page?: unknown
  stays?: unknown
  marketRegions?: unknown
  discovery?: unknown
}

type Slugged = {
  slug?: string
}

// Variables must match the consumers exactly so the seed shares their Apollo
// cache key; they come from the same prehydrated rails props the page reads.
const seedPlace = (
  client: ApolloClient<NormalizedCacheObject>,
  ssr: PlaceSsr | undefined,
  placePage: Slugged | undefined,
  region: Slugged | undefined,
  market: Slugged | undefined,
): void => {
  if (!ssr || !placePage?.slug || !region?.slug || !market?.slug) return

  const pageVariables = {
    marketSlug: market.slug,
    regionSlug: region.slug,
    slug: placePage.slug,
  }

  if (ssr.page) {
    try {
      client.writeQuery({
        query: PlacePageDocument,
        variables: pageVariables,
        data: ssr.page,
      })
    } catch {
      // Best-effort: a malformed payload must not break the render.
    }
  }

  if (ssr.stays) {
    try {
      client.writeQuery({
        query: PlacePageStaysDocument,
        variables: pageVariables,
        data: ssr.stays,
      })
    } catch {
      // Best-effort, as above.
    }
  }

  if (ssr.marketRegions) {
    try {
      client.writeQuery({
        query: PlacePageMarketRegionsDocument,
        variables: pageVariables,
        data: ssr.marketRegions,
      })
    } catch {
      // Best-effort, as above.
    }
  }

  if (ssr.discovery) {
    try {
      client.writeQuery({
        query: PlaceDiscoveryDocument,
        variables: pageVariables,
        data: ssr.discovery,
      })
    } catch {
      // Best-effort, as above.
    }
  }
}

export default seedPlace
